module.exports = __webpack_public_path__ + "img/en-2-3.0251f316.png";